import {
  SerialCertificationApiResponseParam,
  SerialCertificationApiRequestParam,
} from '../types/apis/serialCertificationApi';
import customAxios from '../utils/customAxios';

/**
 * シリアル認証API呼び出し
 * @param reqParams リクエストパラメータ
 * @returns APIレスポンスのPromise
 */
const callSerialCetificationApi = (
  reqParams: SerialCertificationApiRequestParam,
): Promise<SerialCertificationApiResponseParam> => {
  const params = new URLSearchParams();
  params.append('serial', reqParams.serial);
  params.append('device_id', reqParams.deviceId);
  params.append('course_id', reqParams.courseId);

  const response = customAxios
    .post<SerialCertificationApiResponseParam>(
      '/superelmer-server/serial/certification',
      params,
    )
    .then((res) => res.data);

  return response;
};
export default callSerialCetificationApi;
